// extracted by mini-css-extract-plugin
export default {"p-3":"Selects_p-3__gisMa","border":"Selects_border__ACxQc","rounded":"Selects_rounded__JGP7Z","offering-preview":"Selects_offering-preview__+B36+","selects":"Selects_selects__-R20Q"};